<template>
    <div>
        <div class="tit-wrap">
            <h3 class="tit top-line-tit">CIS Nations</h3>
        </div>

        <v-data-table
            :headers="headers"
            :items="items"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            mobile-breakpoint="0"
            @page-count="pageCount = $event"
            class="v-data-table--default v-data-table--no-active"
        ></v-data-table>

        <div class="v-pagination-wrap text-center">
            <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                { text: "P/J Name", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "Client", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "End-User", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "Year", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "Description", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [
                {
                    name: "SGCCUP Project, Uzbekistan",
                    client: "GS E&C",
                    user: "Enter Engineering",
                    year: "2021",
                    description: "Sampling System",
                },
                {
                    name: "SGCCUP Project, Uzbekistan",
                    client: "GS E&C",
                    user: "Enter Engineering",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "ZEECO_UZGTL O2 Analyzer Cabinet, Uzbekistan",
                    client: "ZEECO",
                    user: "UZGTL",
                    year: "2019",
                    description: "O2 Analyzer Cabinet",
                },
                {
                    name: "UZGTL Project, Uzbekistan",
                    client: "HEC",
                    user: "OLTIN YO'L GTL",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "UZONE (Kandym), Uzbekistan",
                    client: "HEC",
                    user: "Lukoil Uzbekistan Operating Company",
                    year: "2015",
                    description: "Analyzer Package and AAQMS with shelter",
                },
                {
                    name: "GTPOGT Project, Turkmenistan",
                    client: "HEC",
                    user: "Petronas Carigali(Turkmenistan) SDN BHD.",
                    year: "2014",
                    description: "Analyzer Package ",
                },
                {
                    name: "Turkmenbashi Oil Refinery Reconstruction Project, Turkmenistan",
                    client: "HDEC",
                    user: "Turkmenbashi Oil Processing Complex",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
